module.exports = __webpack_public_path__ + "img/img0.4b422cc1.jpg";